<template>
  <v-row class="align-center" style="height:100%">
    <v-col cols="7" style="text-align: right;">
      <img src="@/assets/client_top/client_top.png" height="500px" style="margin-left: -1000px; padding-right: 60px" >
    </v-col>
    <v-col cols="5">
      <v-row>
        <v-col cols="12">
          <v-img max-width="240px" src="@/assets/connect_navy.svg" contain></v-img>
        </v-col>
        <v-col cols="4">
          <v-form ref="form">
            <v-container>
              <v-row>
                <ErrorMessage :message="errorMessage"/>
              </v-row>
              <v-row>
                <TextField
                    v-model="data.email"
                    name="メールアドレス"
                    required
                    :submit="submit"
                />
              </v-row>
              <v-row>
                <TextField
                    v-model="data.password"
                    type="password"
                    name="パスワード"
                    required
                    :submit="submit"
                />
              </v-row>
              <v-row>
                <v-btn
                    class="font-weight-bold"
                    depressed
                    height="56px"
                    width="120px"
                    style="border-radius: 10px"
                    color="primary"
                    @click="submit"
                >
                  ログイン
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import {mapActions} from "vuex";
  import TextField from "../../atoms/TextField";
  import ErrorMessage from "../../molecules/ErrorMessage";
  import ComponentMixin from "../../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "page",
    name: "ClientLoginPage",
    isNotLogin: true,
    data() {
      return {
        data: {
          email: "",
          password: "",
          isSubmitted: false,
        },
        errorMessage: null
      }
    },
    computed: {
      isReady () {
        return !this.$auth.loading
      }
    },
    methods: {
      ...mapActions("user", ["login"]),
      submit () {
        if (this.$refs.form.validate() ) {
          this.isSubmitted = true
          if(this.isReady){
            this.$auth.loginEmailAndPassword(this.data.email, this.data.password)
          }
        }
      }
    },
    components: {
      TextField,
      ErrorMessage
    },
    watch: {
      "$auth.user": {
        handler: function(user) {
          if (user) {
            this.go('/clients/jobs')
          }
        }
      },
      "$auth.loading": {
        handler: function(loading) {
          if(!loading && this.isSubmitted && this.$refs.form.validate() ) {
            this.$auth.loginEmailAndPassword(this.data.email, this.data.password)
          }
        }
      }
    }
  }
</script>

<style scoped lang="sass">
.btn-icon
  position: absolute
  left: 10px

</style>
